import { Box, BoxProps, Collapse } from '@chakra-ui/react'
import { FieldMap, FieldMapValue } from '@hb/shared'
import { DataView, SimpleForm, useFormsView } from '@hb/shared-frontend'
import { CSSProperties, useCallback } from 'react'

const collapseStyle: CSSProperties = {
  width: '100%',
}

const formBoxProps: BoxProps = {
  bg: 'white',
  borderRadius: 'md',
  borderWidth: '1px',
  borderColor: 'gray.200',
  p: 1,
}

export const InsuranceInfoForm = ({
  field,
  data,
  onSubmit,
  onCancel,
  isActive,
}: {
  field: FieldMap
  data?: FieldMapValue
  onSubmit: (data: FieldMapValue) => Promise<void>
  onCancel?: () => void
  isActive: boolean
}) => {
  const { assessment } = useFormsView()
  const { submittedOn } = assessment?.assessmentData ?? {}
  const handleSubmit = useCallback(
    async (data: FieldMapValue) => {
      if (!isActive) return { error: 'Stage is inactive' }
      await onSubmit(data)
      return { success: 'Insurance information updated' }
    },
    [onSubmit, isActive],
  )

  return (
    <Collapse style={collapseStyle} in={isActive}>
      <Box pt={0}>
        {submittedOn ? (
          <DataView
            boxProps={formBoxProps}
            field={field}
            data={data}
            onExpandedChange={expanded => {
              if (!expanded && onCancel) onCancel()
            }}
          />
        ) : (
          <SimpleForm
            canSubmitClean
            boxProps={formBoxProps}
            field={field}
            submitText="Next"
            value={data}
            onSubmit={handleSubmit}
          />
        )}
      </Box>
    </Collapse>
  )
}
